// extracted by mini-css-extract-plugin
module.exports = {"tag":"styles_tag__TyYZh","label":"styles_label__NVn3L"};